<template>
  <div class="pageContol listWrap templateList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">我的资源</a>
          <i>></i>
          <a href="javascript:;" @click="init" class="cur-a">课程列表</a>
        </span>
      </div>
      <div class="framePage-body">
        <el-tabs v-model="activeName" :before-leave="beforeTabLeave" @tab-click="tabChange">
<!--          <el-tab-pane label="课程列表" name="first">-->
            <Curriculum ref="first" />
<!--          </el-tab-pane>-->
<!--          <el-tab-pane label="课件列表" name="second">-->
<!--            <Courseware ref="second" />-->
<!--          </el-tab-pane>-->
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import List from "@/mixins/List";
import Curriculum from "@/views/resourse/liananzhong/curriculum.vue";
import Courseware from "@/views/resourse/liananzhong/courseware.vue";
import { resetKeepAlive } from "@/utils/common";
export default {
  name: "courseListLiananzhong",
  components: {
    Courseware,
    Curriculum,
  },
  mixins: [List],
  data() {
    return {
      activeName: "first",
    };
  },
  methods: {
    init() {
      const query = this.$route.query;
      if (query.active) {
        this.activeName = query.active;
      } else {
        this.activeName = "first";
      }
    },
    tabChange(tab) {
      this.$refs[tab.name].getData();
    },
    beforeTabLeave(newName) {
      this.$router.replace({
        path: this.$route.path,
        query: { active: newName },
      });
    },
  },
  beforeRouteLeave: resetKeepAlive,
  watch: {
    $route: function (route) {
      if (route.name != "courseListLiananzhong") return;
      if (route.params.refresh) {
        this.$refs[route.params.refName].getData(-1);
      }
    },
  },
};
</script>
<style lang="less"></style>